import React from "react";
import { stylesheet } from "./stylesheet.compiled";

let isInserted = false;

export class WalrusGlobalStyle extends React.Component<{}, { Icons: React.FC<{}> | null }> {
  static __stylesheet__ = stylesheet;

  state = {
    Icons: null,
  };

  componentDidMount(): void {
    /**
     * We're not React.lazy or React.Suspense for this because it is not supported in SSR for React <18.
     */
    import("./icons").then(({ Icons }) => {
      this.setState({ Icons });
    });

    if (isInserted) {
      return;
    }

    const style = document.createElement("style");
    /**
     * Intentionally insert it at the top of the head so that it forces the
     * global style to be the first CASCADING style sheet. :coffin:
     */
    document.head.prepend(style);

    style.appendChild(document.createTextNode(stylesheet));

    isInserted = true;
  }

  render() {
    if (this.state.Icons) {
      return React.createElement(this.state.Icons);
    }

    return null;
  }
}
